import React from "react";
import { Boxes, Filter, PackageCheck } from "lucide-react";

const StageHeader = () => (
  <>
    <div className="feature-forecasting-steps">
      {[1, 2, 3, 4, 5, 6, 7].map((step, index) => (
        <React.Fragment key={step}>
          <div className={step === 3 ? "step-dot step-dot--active" : "step-dot"}>{step}</div>
          {index < 6 && <div className={step < 3 ? "step-line step-line--done" : "step-line"} />}
        </React.Fragment>
      ))}
    </div>
    <div className="feature-hero">
      <div>
        <span className="feature-eyebrow">Attribute based SKU discovery</span>
        <h2 className="feature-forecasting-title">Feature Based Forecasting</h2>
        <p className="feature-hero-copy">
          Choose a product type, narrow the feature set, and send only the matching SKUs into forecasting.
        </p>
      </div>
      <div className="feature-hero-rail" aria-hidden="true">
        <div className="feature-hero-step">
          <Boxes size={18} />
          <span>Type</span>
        </div>
        <div className="feature-hero-step">
          <Filter size={18} />
          <span>Filters</span>
        </div>
        <div className="feature-hero-step">
          <PackageCheck size={18} />
          <span>SKUs</span>
        </div>
      </div>
    </div>
  </>
);

export default StageHeader;
